var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiario(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF7F41",
    d: "M460,472c0,22-18,40-40,40H110c-22,0-40-18-40-40V40c0-22,18-40,40-40h310c22,0,40,18,40,40V472z  M419.929,472c0.024-0.021,0.051-0.047,0.071-0.072V40.072c-0.021-0.025-0.047-0.052-0.071-0.072H110.071 c-0.024,0.021-0.051,0.047-0.071,0.072v431.855c0.021,0.025,0.047,0.052,0.071,0.072H419.929z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M115,392c0,0-50.069,0-50.104,0C53.85,392.058,44.942,401.059,45,412.104 c0.058,11.011,9.002,19.892,20,19.891L115,432c11.046,0,20-8.954,20-20S126.046,392,115,392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M115,314c0,0-50.069,0-50.104,0C53.85,314.058,44.942,323.059,45,334.104 c0.058,11.011,9.002,19.892,20,19.891L115,354c11.046,0,20-8.954,20-20S126.046,314,115,314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M115,236c0,0-50.069,0-50.104,0C53.85,236.058,44.942,245.059,45,256.104 c0.058,11.011,9.002,19.892,20,19.891L115,276c11.046,0,20-8.954,20-20S126.046,236,115,236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M115,158c0,0-50.069,0-50.104,0C53.85,158.058,44.942,167.059,45,178.104 c0.058,11.011,9.002,19.892,20,19.891L115,198c11.046,0,20-8.954,20-20S126.046,158,115,158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CDBC0",
    d: "M115,80c0,0-50.069,0-50.104,0C53.85,80.058,44.942,89.059,45,100.104c0.058,11.011,9.002,19.892,20,19.891 L115,120c11.046,0,20-8.954,20-20S126.046,80,115,80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3CDBC0",
    points: "340,40.072 340,139.432 320,119.432 300,139.432 300,40.072 260,40.072 260,236 320,176 380,236  380,40.072  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiario);
export default __webpack_public_path__ + "static/media/icon_diario.fafb0c78cb347e53a2087187088d7009.svg";
export { ForwardRef as ReactComponent };